import apiService from './apiService';
import apiServiceNew from './apiService.new';

const mutlipartConfig = {
	headers : {
		'Content-Type': 'multipart/form-data'
	}
};
const storedFilePath = 'storedFile';
const dataFieldName = 'payload';
const getUrlByType = (isPublic) => `${storedFilePath}?isPublic=${isPublic ? 'true' : 'false'}`;
const getCustomUploadURl = (isPublic, isEmailAttachment, advisorID) => `${storedFilePath}/uploadCustomFile?isPublic=${isPublic ? 'true' : 'false'}&isEmailAttachment=${isEmailAttachment}&advisorID=${advisorID}`;
const getUrlById = id => `${storedFilePath}/${id}`;

function create(file, isPublic, config = {}) {
	const formData = new FormData();

	formData.append(dataFieldName, file, file.name);

	return apiServiceNew.post(getUrlByType(isPublic), formData, {
		...mutlipartConfig,
		...config
	}).then(res => res.data);
}

function uploadCustomFile(file, isPublic, isEmailAttachment = false, advisorID, config = {}) {
	const formData = new FormData();

	formData.append(dataFieldName, file, file.name);

	return apiServiceNew.post(getCustomUploadURl(isPublic, isEmailAttachment, advisorID), formData, {
		...mutlipartConfig,
		...config
	}).then(res => res.data);
}

function get(id) {
	return apiServiceNew.get(getUrlById(id)).then(res => res.data);
}

function link(id, options) {
	return `${getUrlById(id)}/download${apiService.paramsToQuery(options)}`;
}

const removeCustomFile = (id) =>
	apiServiceNew.delete(`${getUrlById(id)}/removeCustomFile`);

const getStringData = id =>
	apiServiceNew.get(`${getUrlById(id)}/getStringData`);

export default {
	create: create,
	get: get,
	link: link,
	uploadCustomFile: uploadCustomFile,
	removeCustomFile: removeCustomFile,
	getStringData: getStringData
};
